// === WORKER embebido como BLOB ===
const workerBlob = new Blob([`
    self.onmessage = function (e) {
      const { imageData, width, height, bgColor } = e.data;
  
      function isBackgroundColor([r, g, b]) {
        if (!bgColor) return false;
        
        // Convertir hex a RGB
        const hex = bgColor.replace('#', '');
        const bgR = parseInt(hex.substr(0, 2), 16);
        const bgG = parseInt(hex.substr(2, 2), 16);
        const bgB = parseInt(hex.substr(4, 2), 16);
        
        // Tolerancia para variaciones del color de fondo
        const tolerance = 30;
        return Math.abs(r - bgR) <= tolerance && 
               Math.abs(g - bgG) <= tolerance && 
               Math.abs(b - bgB) <= tolerance;
      }
  
      function getPalette(data, width, height) {
        const colors = {};
        const total = width * height;
  
        for (let i = 0; i < total * 4; i += 4) {
          const r = data[i], g = data[i + 1], b = data[i + 2], a = data[i + 3];
          
          // Solo procesar píxeles con opacidad y que no sean el color de fondo
          if (a > 50 && !isBackgroundColor([r, g, b])) {
            const key = \`\${r},\${g},\${b}\`;
            colors[key] = (colors[key] || 0) + 1;
          }
        }
  
        return Object.entries(colors)
          .map(([k, count]) => ({ color: k.split(',').map(Number), count }))
          .sort((a, b) => b.count - a.count)
          .map(e => e.color);
      }
  
      const palette = getPalette(imageData, width, height);
      const color = palette[0] || [128, 128, 128];
      self.postMessage({ color });
    };
  `], { type: 'application/javascript' });
  
  const worker = new Worker(URL.createObjectURL(workerBlob));
  
  // === LÓGICA PRINCIPAL ===
  const taskQueue = [];
  let isProcessing = false;
  
  function getBackgroundColor() {
    const metaTag = document.getElementById('swatch-bg-color');
    return metaTag ? metaTag.getAttribute('data-color') : null;
  }
  
  function processImageWithWorker(imageData, width, height, prod) {
    return new Promise(resolve => {
      const handleMessage = (e) => {
        const { color } = e.data;
        const rgb = `rgb(${color.join(',')})`;
        const circle = prod.querySelector('.color-circle');
        if (circle) {
          circle.style.backgroundColor = rgb;
          // Si es el producto actual, también aplicar el color al borde
          if (prod.classList.contains('actual_prod-sw')) {
            prod.style.borderColor = rgb;
          }
        } else {
          console.error('No se encontró el elemento .color-circle en:', prod);
        }
        worker.removeEventListener('message', handleMessage);
        resolve();
      };
  
      worker.addEventListener('message', handleMessage);
      worker.postMessage({ 
        imageData, 
        width, 
        height, 
        bgColor: getBackgroundColor() 
      });
    });
  }
  
  function processProduct(prod) {
    return new Promise(resolve => {
      const imageUrl = prod.getAttribute('data-img');
      const productId = prod.getAttribute('data-prod');
      
      if (!imageUrl) {
        console.error('No hay URL de imagen para:', productId);
        return resolve();
      }
  
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = imageUrl;
  
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const size = 50;
  
        canvas.width = size;
        canvas.height = size;
        ctx.drawImage(img, 0, 0, size, size);
  
        const imageData = ctx.getImageData(0, 0, size, size).data;
  
        processImageWithWorker(imageData, size, size, prod).then(resolve);
      };
  
      img.onerror = () => {
        console.error('Error cargando imagen para:', productId, 'URL:', imageUrl);
        resolve();
      };
    });
  }
  
  function runQueue() {
    if (isProcessing || taskQueue.length === 0) return;
  
    isProcessing = true;
    const prod = taskQueue.shift();
  
    processProduct(prod).finally(() => {
      isProcessing = false;
      runQueue();
    });
  }
  
  function enqueueProduct(prod) {
    taskQueue.push(prod);
    runQueue();
  }
  
  // === OBSERVER para lazy loading ===
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
        enqueueProduct(entry.target);
      }
    });
  }, {
    rootMargin: '100px',
    threshold: 0.1
  });
  
  function observeLazyProducts(products) {
    products.forEach(prod => observer.observe(prod));
  }
  
  // === INICIALIZACIÓN ===
  document.addEventListener('DOMContentLoaded', () => {
    
    // Procesar inmediatamente TODOS los productos actuales (sin lazy loading)
    const currentProducts = document.querySelectorAll('.product-color-ss.actual_prod-sw');
    currentProducts.forEach((product, index) => {
      enqueueProduct(product);
    });
    
    // Procesar con lazy loading las otras variantes
    const otherProducts = Array.from(document.querySelectorAll('.product-color-ss:not(.actual_prod-sw)'));
    observeLazyProducts(otherProducts);
  
    const mutationObserver = new MutationObserver(mutations => {
      const lazy = [];
      mutations.forEach(m => {
        m.addedNodes.forEach(node => {
          if (node instanceof Element) {
            // Procesar inmediatamente TODOS los productos actuales nuevos
            node.querySelectorAll('.product-color-ss.actual_prod-sw').forEach(el => {
              enqueueProduct(el);
            });
            // Observar otras variantes para lazy loading
            node.querySelectorAll('.product-color-ss:not(.actual_prod-sw)').forEach(el => {
              lazy.push(el);
            });
          }
        });
      });
      if (lazy.length) {
        observeLazyProducts(lazy);
      }
    });
  
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  });
  